// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== OrdersTable.css ===== */

/* ── B2B / B2C channel pills ── */
.td-channel-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.td-channel-pill--b2b {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}
.td-channel-pill--b2c {
  background: #eff6ff;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}
.dark .td-channel-pill--b2b {
  background: rgba(217,119,6,0.18);
  color: #fcd34d;
  border-color: rgba(217,119,6,0.3);
}
.dark .td-channel-pill--b2c {
  background: rgba(59,130,246,0.15);
  color: #93c5fd;
  border-color: rgba(59,130,246,0.25);
}
.td-channel-pill--swiggy {
  background: #fff1eb;
  color: #c0392b;
  border: 1px solid #f5c6b8;
}
.td-channel-pill--zomato {
  background: #fde8e8;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.td-channel-pill--whatsapp {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.td-channel-pill--ondc {
  background: #f5f3ff;
  color: #5b21b6;
  border: 1px solid #c4b5fd;
}
.dark .td-channel-pill--swiggy {
  background: rgba(192,57,43,0.15);
  color: #fca5a5;
  border-color: rgba(192,57,43,0.3);
}
.dark .td-channel-pill--zomato {
  background: rgba(185,28,28,0.15);
  color: #fca5a5;
  border-color: rgba(185,28,28,0.3);
}
.dark .td-channel-pill--whatsapp {
  background: rgba(6,95,70,0.2);
  color: #6ee7b7;
  border-color: rgba(6,95,70,0.35);
}
.dark .td-channel-pill--ondc {
  background: rgba(91,33,182,0.18);
  color: #c4b5fd;
  border-color: rgba(91,33,182,0.3);
}

/* ── Page background & ambient blobs ── */
.orders-table-page {
  height: calc(100vh - 72px);
  width: 100%;
  background-color: #f8fafc;
  font-family: inherit;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 72px;
  position: relative;
}

.orders-bg-blob-top {
  position: fixed;
  top: -20%;
  right: -10%;
  width: 50%;
  height: 50%;
  background: rgba(96, 165, 250, 0.1);
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  z-index: 0;
}

.orders-bg-blob-bottom {
  position: fixed;
  bottom: -20%;
  left: -10%;
  width: 50%;
  height: 50%;
  background: rgba(192, 132, 252, 0.1);
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  z-index: 0;
}

/* ── Main content layer ── */
.orders-content-layer {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 10;
}

/* ── Sticky top bar (nav tabs + filters) ── */
.orders-topbar {
  position: sticky;
  top: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.3);
  padding: 16px 24px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* ── Order type filter bar (All / Delivery / Dine-in …) ── */
.order-type-filter-container {
  display: inline-flex;
  min-width: max-content;
  align-items: center;
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 6px 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  width: 100%;
}

.order-type-filter-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 12px;
}

.order-type-filter-divider {
  margin: 0 4px;
  height: 32px;
  width: 1px;
  background-color: #e2e8f0;
  flex-shrink: 0;
}

/* ── Order-type pill buttons ── */
.order-type-tab {
  border-radius: 16px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  background-color: transparent;
  color: #475569;
  border: none;
  cursor: pointer;
  outline: none;
  white-space: nowrap;
}

.order-type-tab:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.order-type-tab-active {
  background-color: #2a71ff !important;
  color: #ffffff !important;
  box-shadow:
    0 10px 15px -3px rgba(42, 113, 255, 0.2),
    0 4px 6px -4px rgba(42, 113, 255, 0.2) !important;
}

.order-type-tab-active:hover {
  background-color: #2a71ff !important;
  color: #ffffff !important;
}

/* ── Customer Credit Summary button ── */
.customer-credit-summary-btn {
  margin-left: 12px;
  white-space: nowrap;
  border-radius: 18px;
  padding: 8px 20px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  background-color: rgba(255, 255, 255, 0.5);
  color: #475569;
  border: none;
  cursor: pointer;
  outline: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-transform: none;
}

.customer-credit-summary-btn:hover {
  background-color: #ffffff;
  color: #0f172a;
  box-shadow: none;
  transform: none;
}

.customer-credit-summary-btn--active {
  background-color: #ffffff !important;
  color: #0f172a !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1) !important;
}

.customer-credit-summary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.credit-summary-cross-icon {
  width: 16px;
  height: 16px;
  padding: 3px;
  border-radius: 50%;
  background: #000;
  color: #fff;
  stroke: #fff;
}

/* ── Table scroll wrapper ── */
.custom-table-container {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 24px;
  padding-top: 24px;
}

/* ── Table card shell ── */
.orders-table-card {
  margin: 0 20px;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

/* ── Table itself ── */
.custom-orders-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
  text-align: left;
}

/* Column widths — order history */
.custom-orders-table.orders-cols colgroup col:nth-child(1) {
  width: 11%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(2) {
  width: 13%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(3) {
  width: 17%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(4) {
  width: 14%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(5) {
  width: 8%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(6) {
  width: 11%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(7) {
  width: 11%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(8) {
  width: 11%;
}
.custom-orders-table.orders-cols colgroup col:nth-child(9) {
  width: 10%;
}

/* Column widths — credit summary */
.custom-orders-table.credit-cols colgroup col:nth-child(1) {
  width: 19%;
}
.custom-orders-table.credit-cols colgroup col:nth-child(2) {
  width: 16%;
}
.custom-orders-table.credit-cols colgroup col:nth-child(3) {
  width: 16%;
}
.custom-orders-table.credit-cols colgroup col:nth-child(4) {
  width: 17%;
}
.custom-orders-table.credit-cols colgroup col:nth-child(5) {
  width: 14%;
}
.custom-orders-table.credit-cols colgroup col:nth-child(6) {
  width: 18%;
}

/* ── thead ── */
.custom-orders-table thead {
  border-bottom: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.custom-table-th {
  padding: 14px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  white-space: nowrap;
  border: none;
}

/* ── tbody rows ── */
.custom-orders-table tbody {
  divide-color: #f1f5f9;
}

.custom-table-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s;
  cursor: pointer;
}

.custom-table-row:last-child {
  border-bottom: none;
}

.custom-table-row:hover {
  background-color: rgba(248, 250, 252, 0.5);
}

.custom-table-row.selected-row {
  background-color: rgba(25, 118, 210, 0.06);
}

.custom-table-td {
  padding: 14px 16px;
  font-size: 13px;
  color: #475569;
  border: none;
  vertical-align: middle;
}

/* ── Order ID cell ── */
.td-order-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.td-order-id span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Date cell ── */
.td-date-primary {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: 500;
  color: #0f172a;
}

.td-date-secondary {
  font-size: 11px;
  color: #64748b;
}

/* ── Customer cell ── */
.td-customer-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.td-customer-phone {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  color: #64748b;
}

/* ── Source cell ── */
.td-source-pill {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}

.td-source-aggregator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.td-source-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
  flex-shrink: 0;
  padding: 4px;
}

.td-source-badge--zomato {
  background-color: #dc2626;
}
.td-source-badge--swiggy {
  background-color: #f97316;
}
.td-source-badge--default {
  background-color: #475569;
}

.td-source-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  color: #334155;
}

/* ── Items cell ── */
.td-items {
  font-size: 12.5px;
  color: #475569;
}

/* ── Total / amount cell ── */
.td-amount {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

/* ── Payment method pill ── */
.td-payment-method-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}

/* ── Payment status badge ── */
.td-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  border-radius: 15px;
  border: 1px solid;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Status colour variants */
.td-status-badge--paid {
  border-color: #a7f3d0;
  background-color: #ecfdf5;
  color: #065f46;
}

.td-status-badge--created {
  border-color: #bfdbfe;
  background-color: #eff6ff;
  color: #1d4ed8;
}

.td-status-badge--pending {
  border-color: #fde68a;
  background-color: #fffbeb;
  color: #92400e;
}

.td-status-badge--cancelled,
.td-status-badge--payment-cancelled {
  border-color: #fecaca;
  background-color: #fef2f2;
  color: #991b1b;
}

.td-status-badge--adjusted {
  border-color: #fecaca;
  background-color: #fef2f2;
  color: #991b1b;
}

.td-status-badge--partial-paid {
  border-color: #fde68a;
  background-color: #fffbeb;
  color: #92400e;
}

.td-status-badge--refunded {
  border-color: #fecaca;
  background-color: #fef2f2;
  color: #be123c;
}

.td-status-badge--default {
  border-color: #e2e8f0;
  background-color: #f8fafc;
  color: #475569;
}

/* ── Actions cell ── */
.td-actions {
  text-align: right;
}

.details-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border: 1px solid transparent;
  border-radius: 9999px;
  padding: 0 12px;
  height: 32px;
  min-height: 32px;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s;
  outline: none;
}

.details-btn:hover {
  background-color: #f1f5f9;
}

/* ── Credit summary table specific ── */
.td-outstanding-amount-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #fde68a;
  background-color: #fffbeb;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
}

.td-invoice-aging-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #334155;
}

/* ── Loading / empty state ── */
.order-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 400px;
  width: 100%;
}

.customer-no-data-box {
  height: 525px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ── Mobile order cards ── */
.order-main-container {
  margin-top: 3.2rem;
  width: 100%;
}

.order-item-container {
  margin: 1rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

/* ── Order details inline page ── */
.order-details-page {
  width: calc(100% - 120px);
  height: 100%;
  background-color: white;
  margin-top: 85px;
  margin-left: 17px;
  border-radius: 8px;
}

/* ── Legacy super-app status classes (kept for backwards compat) ── */
.super-app.Paid {
  color: #69e86d;
  font-size: 1em;
  font-weight: 600;
  padding: 5px;
}
.super-app.Create {
  color: blue;
  font-size: 1em;
  font-weight: 600;
  padding: 5px;
}
.super-app.Adjust {
  color: darkred;
  font-size: 1em;
  font-weight: 600;
  padding: 5px;
}
.super-app.Pending {
  color: orange;
  font-size: 1em;
  font-weight: 600;
  padding: 5px;
}
.super-app.Cancel {
  color: red;
  font-size: 1em;
  font-weight: 600;
  padding: 5px;
}
.super-app.Payment_Cancel {
  color: red;
  font-size: 0.75em;
  font-weight: 900;
  padding: 5px;
}
.super-app.Partial_Paid {
  color: orange;
  font-size: 1em;
  font-weight: 900;
  padding: 5px;
}

/* ── Dark mode overrides ── */
.dark .orders-table-page {
  background-color: #0f172a;
  color: #f8fafc;
}
.dark .orders-topbar {
  background: rgba(15, 23, 42, 0.5);
  border-color: rgba(255, 255, 255, 0.08);
}
.dark .order-type-filter-container {
  background-color: rgba(30, 41, 59, 0.8);
  border-color: rgba(71, 85, 105, 0.8);
}
.dark .order-type-filter-divider {
  background-color: rgba(71, 85, 105, 0.8);
}
.dark .order-type-tab {
  color: #94a3b8;
}
.dark .order-type-tab:hover {
  background-color: #334155;
  color: #f8fafc;
}
.dark .order-type-tab-active {
  background-color: #2a71ff !important;
  color: #ffffff !important;
}
.dark .customer-credit-summary-btn {
  background-color: rgba(30, 41, 59, 0.5);
  color: #94a3b8;
}
.dark .customer-credit-summary-btn:hover {
  background-color: #1e293b;
  color: #f8fafc;
}
.dark .orders-table-card {
  background: #1e293b;
  border-color: rgba(71, 85, 105, 0.8);
}
.dark .custom-orders-table thead {
  background-color: #1e293b;
}
.dark .custom-table-th {
  color: #94a3b8;
  border-color: rgba(71, 85, 105, 0.6);
}
.dark .custom-table-td {
  color: #cbd5e1;
  border-color: rgba(71, 85, 105, 0.4);
}
.dark .custom-table-row:hover {
  background-color: rgba(255, 255, 255, 0.04);
}
.dark .custom-table-row.selected-row {
  background-color: rgba(42, 113, 255, 0.12);
}
.dark .td-customer-name {
  color: #f1f5f9;
}
.dark .td-amount {
  color: #f1f5f9;
}
.dark .td-order-id {
  color: #cbd5e1;
}
.dark .td-date-primary {
  color: #e2e8f0;
}
.dark .order-details-page {
  background-color: #353a50;
  color: white;
}
.dark .order-loader-container {
  color: white;
}
.dark .super-app.Paid {
  color: #69e86d !important;
}
.dark .super-app.Create {
  color: #60a5fa !important;
}
.dark .super-app.Adjust {
  color: #f87171 !important;
}
.dark .super-app.Cancel {
  color: #f87171 !important;
}

/* Header styling for Customer Credit Summary List */
.credit-summary-list-header {
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);
  transition: background-color 0.3s ease, border-color 0.3s ease;
  margin-bottom: 24px;
}

.credit-summary-list-header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.credit-summary-list-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.credit-summary-list-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #45556C;
  padding: 0;
}

.credit-summary-list-back-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

.credit-summary-list-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  margin: 0;
  color: #0f172a;
}

/* Dark mode overrides for Header styling */
.dark .credit-summary-list-header {
  background-color: #1e293b;
  border-bottom: 1px solid #334155;
}

.dark .credit-summary-list-back-btn {
  background-color: #334155;
  border-color: #334155;
  color: #cbd5e1;
}

.dark .credit-summary-list-back-btn:hover {
  background-color: #334155;
  color: #f8fafc;
}

.dark .credit-summary-list-title {
  color: #f8fafc;
}

.orders-table-page-standalone {
  margin-top: 54px;
  height: calc(100vh - 54px);
  width: 100%;
  overflow-y: auto;
}

`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/OrdersTable.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iDAAiD;EACjD,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB;;qDAEmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gDAAgD;EAChD,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* ===== OrdersTable.css ===== */\n\n/* ── B2B / B2C channel pills ── */\n.td-channel-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 9px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n.td-channel-pill--b2b {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n}\n.td-channel-pill--b2c {\n  background: #eff6ff;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n.dark .td-channel-pill--b2b {\n  background: rgba(217,119,6,0.18);\n  color: #fcd34d;\n  border-color: rgba(217,119,6,0.3);\n}\n.dark .td-channel-pill--b2c {\n  background: rgba(59,130,246,0.15);\n  color: #93c5fd;\n  border-color: rgba(59,130,246,0.25);\n}\n.td-channel-pill--swiggy {\n  background: #fff1eb;\n  color: #c0392b;\n  border: 1px solid #f5c6b8;\n}\n.td-channel-pill--zomato {\n  background: #fde8e8;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n.td-channel-pill--whatsapp {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #6ee7b7;\n}\n.td-channel-pill--ondc {\n  background: #f5f3ff;\n  color: #5b21b6;\n  border: 1px solid #c4b5fd;\n}\n.dark .td-channel-pill--swiggy {\n  background: rgba(192,57,43,0.15);\n  color: #fca5a5;\n  border-color: rgba(192,57,43,0.3);\n}\n.dark .td-channel-pill--zomato {\n  background: rgba(185,28,28,0.15);\n  color: #fca5a5;\n  border-color: rgba(185,28,28,0.3);\n}\n.dark .td-channel-pill--whatsapp {\n  background: rgba(6,95,70,0.2);\n  color: #6ee7b7;\n  border-color: rgba(6,95,70,0.35);\n}\n.dark .td-channel-pill--ondc {\n  background: rgba(91,33,182,0.18);\n  color: #c4b5fd;\n  border-color: rgba(91,33,182,0.3);\n}\n\n/* ── Page background & ambient blobs ── */\n.orders-table-page {\n  height: calc(100vh - 72px);\n  width: 100%;\n  background-color: #f8fafc;\n  font-family: inherit;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: 72px;\n  position: relative;\n}\n\n.orders-bg-blob-top {\n  position: fixed;\n  top: -20%;\n  right: -10%;\n  width: 50%;\n  height: 50%;\n  background: rgba(96, 165, 250, 0.1);\n  border-radius: 50%;\n  filter: blur(120px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.orders-bg-blob-bottom {\n  position: fixed;\n  bottom: -20%;\n  left: -10%;\n  width: 50%;\n  height: 50%;\n  background: rgba(192, 132, 252, 0.1);\n  border-radius: 50%;\n  filter: blur(120px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* ── Main content layer ── */\n.orders-content-layer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  z-index: 10;\n}\n\n/* ── Sticky top bar (nav tabs + filters) ── */\n.orders-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.3);\n  padding: 16px 24px;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n/* ── Order type filter bar (All / Delivery / Dine-in …) ── */\n.order-type-filter-container {\n  display: inline-flex;\n  min-width: max-content;\n  align-items: center;\n  border-radius: 24px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 6px 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  width: 100%;\n}\n\n.order-type-filter-tabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding-right: 12px;\n}\n\n.order-type-filter-divider {\n  margin: 0 4px;\n  height: 32px;\n  width: 1px;\n  background-color: #e2e8f0;\n  flex-shrink: 0;\n}\n\n/* ── Order-type pill buttons ── */\n.order-type-tab {\n  border-radius: 16px;\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n  background-color: transparent;\n  color: #475569;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  white-space: nowrap;\n}\n\n.order-type-tab:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.order-type-tab-active {\n  background-color: #2a71ff !important;\n  color: #ffffff !important;\n  box-shadow:\n    0 10px 15px -3px rgba(42, 113, 255, 0.2),\n    0 4px 6px -4px rgba(42, 113, 255, 0.2) !important;\n}\n\n.order-type-tab-active:hover {\n  background-color: #2a71ff !important;\n  color: #ffffff !important;\n}\n\n/* ── Customer Credit Summary button ── */\n.customer-credit-summary-btn {\n  margin-left: 12px;\n  white-space: nowrap;\n  border-radius: 18px;\n  padding: 8px 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n  background-color: rgba(255, 255, 255, 0.5);\n  color: #475569;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-transform: none;\n}\n\n.customer-credit-summary-btn:hover {\n  background-color: #ffffff;\n  color: #0f172a;\n  box-shadow: none;\n  transform: none;\n}\n\n.customer-credit-summary-btn--active {\n  background-color: #ffffff !important;\n  color: #0f172a !important;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1) !important;\n}\n\n.customer-credit-summary-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.credit-summary-cross-icon {\n  width: 16px;\n  height: 16px;\n  padding: 3px;\n  border-radius: 50%;\n  background: #000;\n  color: #fff;\n  stroke: #fff;\n}\n\n/* ── Table scroll wrapper ── */\n.custom-table-container {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 24px;\n  padding-top: 24px;\n}\n\n/* ── Table card shell ── */\n.orders-table-card {\n  margin: 0 20px;\n  overflow: hidden;\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n/* ── Table itself ── */\n.custom-orders-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  font-size: 13px;\n  text-align: left;\n}\n\n/* Column widths — order history */\n.custom-orders-table.orders-cols colgroup col:nth-child(1) {\n  width: 11%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(2) {\n  width: 13%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(3) {\n  width: 17%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(4) {\n  width: 14%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(5) {\n  width: 8%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(6) {\n  width: 11%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(7) {\n  width: 11%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(8) {\n  width: 11%;\n}\n.custom-orders-table.orders-cols colgroup col:nth-child(9) {\n  width: 10%;\n}\n\n/* Column widths — credit summary */\n.custom-orders-table.credit-cols colgroup col:nth-child(1) {\n  width: 19%;\n}\n.custom-orders-table.credit-cols colgroup col:nth-child(2) {\n  width: 16%;\n}\n.custom-orders-table.credit-cols colgroup col:nth-child(3) {\n  width: 16%;\n}\n.custom-orders-table.credit-cols colgroup col:nth-child(4) {\n  width: 17%;\n}\n.custom-orders-table.credit-cols colgroup col:nth-child(5) {\n  width: 14%;\n}\n.custom-orders-table.credit-cols colgroup col:nth-child(6) {\n  width: 18%;\n}\n\n/* ── thead ── */\n.custom-orders-table thead {\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n}\n\n.custom-table-th {\n  padding: 14px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n  white-space: nowrap;\n  border: none;\n}\n\n/* ── tbody rows ── */\n.custom-orders-table tbody {\n  divide-color: #f1f5f9;\n}\n\n.custom-table-row {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background-color 0.15s;\n  cursor: pointer;\n}\n\n.custom-table-row:last-child {\n  border-bottom: none;\n}\n\n.custom-table-row:hover {\n  background-color: rgba(248, 250, 252, 0.5);\n}\n\n.custom-table-row.selected-row {\n  background-color: rgba(25, 118, 210, 0.06);\n}\n\n.custom-table-td {\n  padding: 14px 16px;\n  font-size: 13px;\n  color: #475569;\n  border: none;\n  vertical-align: middle;\n}\n\n/* ── Order ID cell ── */\n.td-order-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.td-order-id span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Date cell ── */\n.td-date-primary {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.td-date-secondary {\n  font-size: 11px;\n  color: #64748b;\n}\n\n/* ── Customer cell ── */\n.td-customer-name {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.td-customer-phone {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  color: #64748b;\n}\n\n/* ── Source cell ── */\n.td-source-pill {\n  display: inline-flex;\n  max-width: 100%;\n  align-items: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.td-source-aggregator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.td-source-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #ffffff;\n  flex-shrink: 0;\n  padding: 4px;\n}\n\n.td-source-badge--zomato {\n  background-color: #dc2626;\n}\n.td-source-badge--swiggy {\n  background-color: #f97316;\n}\n.td-source-badge--default {\n  background-color: #475569;\n}\n\n.td-source-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12.5px;\n  color: #334155;\n}\n\n/* ── Items cell ── */\n.td-items {\n  font-size: 12.5px;\n  color: #475569;\n}\n\n/* ── Total / amount cell ── */\n.td-amount {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* ── Payment method pill ── */\n.td-payment-method-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* ── Payment status badge ── */\n.td-status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 72px;\n  border-radius: 15px;\n  border: 1px solid;\n  padding: 4px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n/* Status colour variants */\n.td-status-badge--paid {\n  border-color: #a7f3d0;\n  background-color: #ecfdf5;\n  color: #065f46;\n}\n\n.td-status-badge--created {\n  border-color: #bfdbfe;\n  background-color: #eff6ff;\n  color: #1d4ed8;\n}\n\n.td-status-badge--pending {\n  border-color: #fde68a;\n  background-color: #fffbeb;\n  color: #92400e;\n}\n\n.td-status-badge--cancelled,\n.td-status-badge--payment-cancelled {\n  border-color: #fecaca;\n  background-color: #fef2f2;\n  color: #991b1b;\n}\n\n.td-status-badge--adjusted {\n  border-color: #fecaca;\n  background-color: #fef2f2;\n  color: #991b1b;\n}\n\n.td-status-badge--partial-paid {\n  border-color: #fde68a;\n  background-color: #fffbeb;\n  color: #92400e;\n}\n\n.td-status-badge--refunded {\n  border-color: #fecaca;\n  background-color: #fef2f2;\n  color: #be123c;\n}\n\n.td-status-badge--default {\n  border-color: #e2e8f0;\n  background-color: #f8fafc;\n  color: #475569;\n}\n\n/* ── Actions cell ── */\n.td-actions {\n  text-align: right;\n}\n\n.details-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border: 1px solid transparent;\n  border-radius: 9999px;\n  padding: 0 12px;\n  height: 32px;\n  min-height: 32px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  outline: none;\n}\n\n.details-btn:hover {\n  background-color: #f1f5f9;\n}\n\n/* ── Credit summary table specific ── */\n.td-outstanding-amount-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #fde68a;\n  background-color: #fffbeb;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.td-invoice-aging-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* ── Loading / empty state ── */\n.order-loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-height: 400px;\n  width: 100%;\n}\n\n.customer-no-data-box {\n  height: 525px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ── Mobile order cards ── */\n.order-main-container {\n  margin-top: 3.2rem;\n  width: 100%;\n}\n\n.order-item-container {\n  margin: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.order-pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n/* ── Order details inline page ── */\n.order-details-page {\n  width: calc(100% - 120px);\n  height: 100%;\n  background-color: white;\n  margin-top: 85px;\n  margin-left: 17px;\n  border-radius: 8px;\n}\n\n/* ── Legacy super-app status classes (kept for backwards compat) ── */\n.super-app.Paid {\n  color: #69e86d;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 5px;\n}\n.super-app.Create {\n  color: blue;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 5px;\n}\n.super-app.Adjust {\n  color: darkred;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 5px;\n}\n.super-app.Pending {\n  color: orange;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 5px;\n}\n.super-app.Cancel {\n  color: red;\n  font-size: 1em;\n  font-weight: 600;\n  padding: 5px;\n}\n.super-app.Payment_Cancel {\n  color: red;\n  font-size: 0.75em;\n  font-weight: 900;\n  padding: 5px;\n}\n.super-app.Partial_Paid {\n  color: orange;\n  font-size: 1em;\n  font-weight: 900;\n  padding: 5px;\n}\n\n/* ── Dark mode overrides ── */\n.dark .orders-table-page {\n  background-color: #0f172a;\n  color: #f8fafc;\n}\n.dark .orders-topbar {\n  background: rgba(15, 23, 42, 0.5);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n.dark .order-type-filter-container {\n  background-color: rgba(30, 41, 59, 0.8);\n  border-color: rgba(71, 85, 105, 0.8);\n}\n.dark .order-type-filter-divider {\n  background-color: rgba(71, 85, 105, 0.8);\n}\n.dark .order-type-tab {\n  color: #94a3b8;\n}\n.dark .order-type-tab:hover {\n  background-color: #334155;\n  color: #f8fafc;\n}\n.dark .order-type-tab-active {\n  background-color: #2a71ff !important;\n  color: #ffffff !important;\n}\n.dark .customer-credit-summary-btn {\n  background-color: rgba(30, 41, 59, 0.5);\n  color: #94a3b8;\n}\n.dark .customer-credit-summary-btn:hover {\n  background-color: #1e293b;\n  color: #f8fafc;\n}\n.dark .orders-table-card {\n  background: #1e293b;\n  border-color: rgba(71, 85, 105, 0.8);\n}\n.dark .custom-orders-table thead {\n  background-color: #1e293b;\n}\n.dark .custom-table-th {\n  color: #94a3b8;\n  border-color: rgba(71, 85, 105, 0.6);\n}\n.dark .custom-table-td {\n  color: #cbd5e1;\n  border-color: rgba(71, 85, 105, 0.4);\n}\n.dark .custom-table-row:hover {\n  background-color: rgba(255, 255, 255, 0.04);\n}\n.dark .custom-table-row.selected-row {\n  background-color: rgba(42, 113, 255, 0.12);\n}\n.dark .td-customer-name {\n  color: #f1f5f9;\n}\n.dark .td-amount {\n  color: #f1f5f9;\n}\n.dark .td-order-id {\n  color: #cbd5e1;\n}\n.dark .td-date-primary {\n  color: #e2e8f0;\n}\n.dark .order-details-page {\n  background-color: #353a50;\n  color: white;\n}\n.dark .order-loader-container {\n  color: white;\n}\n.dark .super-app.Paid {\n  color: #69e86d !important;\n}\n.dark .super-app.Create {\n  color: #60a5fa !important;\n}\n.dark .super-app.Adjust {\n  color: #f87171 !important;\n}\n.dark .super-app.Cancel {\n  color: #f87171 !important;\n}\n\n/* Header styling for Customer Credit Summary List */\n.credit-summary-list-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n  margin-bottom: 24px;\n}\n\n.credit-summary-list-header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.credit-summary-list-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.credit-summary-list-back-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #45556C;\n  padding: 0;\n}\n\n.credit-summary-list-back-btn:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n}\n\n.credit-summary-list-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  margin: 0;\n  color: #0f172a;\n}\n\n/* Dark mode overrides for Header styling */\n.dark .credit-summary-list-header {\n  background-color: #1e293b;\n  border-bottom: 1px solid #334155;\n}\n\n.dark .credit-summary-list-back-btn {\n  background-color: #334155;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n\n.dark .credit-summary-list-back-btn:hover {\n  background-color: #334155;\n  color: #f8fafc;\n}\n\n.dark .credit-summary-list-title {\n  color: #f8fafc;\n}\n\n.orders-table-page-standalone {\n  margin-top: 54px;\n  height: calc(100vh - 54px);\n  width: 100%;\n  overflow-y: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
